import FormBuilderConfig from "../../../../toolkit/baseForms2/formBuilder/FormBuilder.config";
import ISelectBuilder from "../../../../toolkit/baseForms2/iSelectBuilder/ISelectBuilder";
import ITypeSelectBuilder from "../../../../toolkit/baseForms2/iTypeSelectBuilder/ITypeSelectBuilder";

export type Inputs = "tipoBusqueda" | "region" | "club";
export type Buttons = never;

const hiddenIfClubes = formValue => formValue.tipoBusqueda === "CLUBES";
const hiddenIfNotClubes = formValue =>
  !formValue.tipoBusqueda || formValue.tipoBusqueda !== "CLUBES";

export const filtrosFormConfig: FormBuilderConfig<Inputs, Buttons> = {
  inputs: [
    {
      name: "tipoBusqueda",
      label: "Filtrar por",
      bts: {
        mCol: 6
      },
      component: ISelectBuilder,
      props: {
        emptyLabel: "Regiones",
        data: [{ value: "CLUBES", label: "Clubes" }]
      }
    },
    {
      name: "region",
      label: "Región",
      bts: {
        mCol: 6
      },
      component: ISelectBuilder,
      props: {
        emptyLabel: "Todas las regiones",
        hidden: hiddenIfClubes
        // data se sobrescribe en el componente con children
      }
    },
    {
      name: "club",
      label: "Club",
      bts: {
        mCol: 6
      },
      component: ITypeSelectBuilder,
      props: {
        emptyLabel: "Todos los clubes",
        hidden: hiddenIfNotClubes
        // data se sobrescribe en el componente con children
      }
    }
  ],
  buttons: [],
  validations: {},
  rows: [["tipoBusqueda", "region", "club"]]
};
